import React from 'react'
import './App.css'
import './Home.css'
import { Link } from 'react-router-dom'
import Axios from 'axios'
import { BsArrowRight } from 'react-icons/bs'
import { IoIosArrowBack } from 'react-icons/io'
import Header from './layouts/Header'
import Header2 from './components/Header2'
import { API_URL } from './config'

class Categories extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      eventcategory: [],
      loading: true,
      error: '',
    }
  }

  componentDidMount() {
    document.title = 'Categories - Karamale'

    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=EVENTCATEGORY&limit=`)
      .then((response) => {
        this.setState({
          eventcategory: Array.isArray(response.data) ? response.data : [],
          loading: false,
        })
      })
      .catch(() => {
        this.setState({
          loading: false,
          error: 'We couldn’t load the categories.',
        })
      })
  }

  render() {
    const { eventcategory, loading, error } = this.state
    const loggedIn = localStorage.getItem('customername') !== null

    return (
      <div className="kx-page">
        {loggedIn ? <Header2 /> : <Header />}

        <main>
          <section className="kx-section kx-categories">
            <div className="kx-wrap">
              <div className="kx-head kx-categories__head">
                <div>
                  <button
                    type="button"
                    className="kx-back"
                    onClick={() => this.props.history.goBack()}
                  >
                    <IoIosArrowBack aria-hidden="true" />
                    <span>Back</span>
                  </button>

                  <h1 className="kx-head__title">Explore by category</h1>

                  <p className="kx-head__sub">Find events that match what you're looking for.</p>
                </div>

                {!loading && !error && (
                  <span className="kx-head__count">
                    {eventcategory.length} {eventcategory.length === 1 ? 'category' : 'categories'}
                  </span>
                )}
              </div>

              {loading && (
                <div className="kx-category-grid" aria-busy="true" aria-label="Loading categories">
                  {Array.from({ length: 9 }).map((_, index) => (
                    <div className="kx-category-skeleton" key={index}>
                      <div className="kx-category-skeleton__line" />
                      <div className="kx-category-skeleton__arrow" />
                    </div>
                  ))}
                </div>
              )}

              {!loading && error && (
                <div className="kx-state">
                  <h3>We couldn't load categories</h3>

                  <p>Check your connection and try again.</p>

                  <button
                    type="button"
                    className="kx-btn kx-btn--ink"
                    onClick={() => window.location.reload()}
                  >
                    Try again
                  </button>
                </div>
              )}

              {!loading && !error && eventcategory.length > 0 && (
                <div className="kx-category-grid">
                  {eventcategory.map((item, index) => (
                    <Link
                      key={`${item.category}-${index}`}
                      to={{
                        pathname: '/category',
                        state: {
                          fromHome: true,
                          provinceid: item.provinceid,
                          category: item.category,
                          province: item.province,
                        },
                      }}
                      className="kx-category-card"
                    >
                      <span className="kx-category-card__name">{item.category}</span>

                      <span className="kx-category-card__arrow">
                        <BsArrowRight aria-hidden="true" />
                      </span>
                    </Link>
                  ))}
                </div>
              )}

              {!loading && !error && eventcategory.length === 0 && (
                <div className="kx-state">
                  <h3>No categories found</h3>

                  <p>There are currently no event categories available.</p>
                </div>
              )}
            </div>
          </section>
        </main>
      </div>
    )
  }
}

export default Categories
